import DataDisplayRowI from "../DataDisplayRowI";
import getDealerRow from "../DataDisplayRow/DealerRow";
import DataDisplayTable from "../DataDisplayTable";

class DealerTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getDealerRow()
    }
}

let dealerTable: DealerTable | null = null;

export default function getDealerTable(): DealerTable {
    if (dealerTable === null)
        dealerTable = new DealerTable()
    return dealerTable
}